module.exports = __webpack_public_path__ + "static/media/lifelong.92e0434.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/lifelong.mp4
// module id = bHo/
// module chunks = 1